var jade = require("/opt/codecombat/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (view) {
buf.push("<form class=\"modal-body eu-confirmation\"><div class=\"modal-body-content\"><div class=\"checkbox\"><label for=\"eu-confirmation-checkbox\" class=\"control-label\"><input id=\"eu-confirmation-checkbox\" type=\"checkbox\" value=\"\"" + (jade.attr("checked", view.state.get('euConfirmationGranted'), true, true)) + "><span data-i18n=\"signup.eu_confirmation\"></span></label></div><p><em><a href=\"/privacy#place-of-processing\" target=\"_blank\" data-i18n=\"signup.eu_confirmation_place_of_processing\"></a></em></p><br><br>");
switch (view.signupState.get('path')){
case 'student':
buf.push("<p data-i18n=\"signup.eu_confirmation_student\" class=\"small\"></p>");
  break;
case 'individual':
buf.push("<p data-i18n=\"signup.eu_confirmation_individual\" class=\"small\">   </p>");
  break;
}
buf.push("</div><!-- In reverse order for tabbing purposes--><div class=\"history-nav-buttons\"><button type=\"button\"" + (jade.attr("disabled", !view.state.get('euConfirmationGranted'), true, true)) + " class=\"forward-button btn btn-lg btn-navy\"><span data-i18n=\"common.continue\"></span></button><button type=\"button\" class=\"back-button btn btn-lg btn-navy-alt\"><span data-i18n=\"common.back\"></span></button></div></form>");}.call(this,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/eu-confirmation-view.jade
// module id = 826
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91